import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_ADM_MYCHART_USER_ID_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { AdmMyChartUserIdPayload, AdmMyChartUserIdResult } from '../types/getAdmMyChartUserId.types';

/**
 * Retrieves the MyChart user ID for either the authenticated user or one of
 * their dependants.
 *
 * - For the authenticated user (self), no `MemberPrn` is required.
 * - For a dependant, `MemberPrn` must be provided to identify the dependant.
 *
 * @param builder RTK Query endpoint builder.
 * @returns An endpoint that returns the corresponding MyChart user ID.
 * This id can be used for getPatientMaster
 */

export const getAdmMyChartUserId = (builder: BuilderType) =>
  builder.query<AdmMyChartUserIdResult, AdmMyChartUserIdPayload>({
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_ADM_MYCHART_USER_ID_URL,
    }),
    transformResponse: (response: GenericApiResponse<AdmMyChartUserIdResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
